import { Field, useFormikContext } from "formik";
import { useCaseViewStyle } from "../../../components/CaseView/useCaseViewStyle";

import { CaseDataResponse } from "../../../types/CaseTypes";
import { Typography } from "@mui/material";
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";

function BudgetSection() {
  const classes = useCaseViewStyle();
  const { values } = useFormikContext<CaseDataResponse>();

  return (
    <div className={classes.rightContainer}>
      <div className={classes.rightInformationDiv}>
        <div className={classes.cardHead}>
          <span className={classes.cardHeadIcon}>
            <PaymentsOutlinedIcon />
          </span>
          <h5 className={classes.tabHeading}>Budget</h5>
        </div>
        <div className={classes.budgetContainer}>
          <div className={`budgetRow`}>
            <Typography variant={"h6"}>Scheduled Budget</Typography>
            <Field
              name={`case_detail.case_details.budget_information.scheduled`}
              type={"number"}
              // className={"field"}
              className={classes.formikInput}
              style={{ width: "130px", textAlign: "right" }}
            />
          </div>
          <div className={`budgetRow`}>
            <Typography variant={"h6"}>Budget Used</Typography>
            <Field
              name={`case_detail.case_details.budget_information.used`}
              type={"number"}
              // className={"field"}
              className={classes.formikInput}
              style={{ width: "130px", textAlign: "right" }}
            />
          </div>
          <div className={"bottomRow"}>
            <span className={"remLabel"}>Budget Remaining</span>
            <span className={"remaining"}>
              {(values.case_detail.case_details.budget_information?.scheduled ||
                0) -
                (values.case_detail.case_details.budget_information?.used || 0)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BudgetSection;
